export const appsAppGroupIdTeamsTeamIdSummary = "/apps/:app_group_id/teams/:team_id/summary";
